import Vue from "vue";
import VueRouter from "vue-router";
import flyRoutes from "./fly.routes.js";
import websiteRoutes from "./website.routes.js";
import widgetRoutes from "./widget.routes";
import { isValidSubdomain } from "@/utils/domainConfig";
Vue.use(VueRouter);

// Determine if we're on a site subdomain
const hostname = window.location.hostname;
  const isSiteSubdomain = isValidSubdomain(hostname, 'stores') || isValidSubdomain(hostname, 'landing');

// Use only website routes for site subdomains, otherwise use all routes
const routes = isSiteSubdomain
  ? websiteRoutes
  : [...widgetRoutes, ...flyRoutes, ...websiteRoutes];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
router.beforeEach((to, from, next) => {
  if (to.name === "planner") {
    // Replace 'planner' with your planner route name
    document.body.classList.add("planner-page");
  } else {
    document.body.classList.remove("planner-page");
  }
  next();
});

// Fix for NavigationDuplicated error
const originalPush = router.push;
router.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") throw err;
  });
};

const originalReplace = router.replace;
router.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") throw err;
  });
};

export default router;
